import { createTheme } from '@mui/material';

export const theme = createTheme({
  typography: {
    fontFamily: ['PT Serif, serif'].join(','),
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: `
        body {
          font-family: PT Serif, serif'
        }
      `,
    },
    MuiPopover: {
      styleOverrides: {
        root: {
          '.MuiPopover-paper': {
            borderRadius: '0',
            padding: '10px',
            border: '1px solid var(--orange)',
          },
        },
      },
    },
    MuiFormGroup: {
      styleOverrides: {
        root: {
          display: 'grid',
          gap: '20px',
        },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        root: {
          padding: '0',
          border: '1px solid var(--border-grey)',
          textarea: {
            padding: '5px 10px',
          },
        },
      },
    },
    MuiFormControlLabel: {
      styleOverrides: {
        root: {
          margin: '0',
        },
        label: {
          lineHeight: '15px',
          letterSpacing: '0.005em',
          margin: '0 3px 0 8px',
          fontSize: 'var(--fs-small-plus)',
        },
      },
    },
    MuiRadio: {
      styleOverrides: {
        root: {
          padding: '0',
        },
        colorPrimary: {
          width: '28px',
          height: '28px',
          border: '1px solid var(--border-grey)',
          transition: '.2s ease',
          svg: {
            opacity: '0',
            width: '75%',
            height: '75%',
          },
          '&:hover': {
            background: 'none',
            border: '1px solid var(--orange)',
          },
          '&.Mui-checked': {
            svg: {
              opacity: '1',
            },
          },
        },
      },
    },
  },
});
